import React from 'react';
import PropTypes from 'prop-types';

const YRMapLegend = ({ legendData }) => (
    <div className="yr-map-legend">
        <div className="yr-map-legend__item">
            <div className="yr-map-legend__circle" />
            <div className="yr-map-legend__value">0-{legendData[0].min}</div>
        </div>
        {legendData.map((legendItem, index) => (
            <div className="yr-map-legend__item" key={`${legendItem.min}-${legendItem.max}`}>
                <div className="yr-map-legend__circle" />
                {index === (legendData.length - 1) ? (
                    <div className="yr-map-legend__value">&gt;{legendItem.min}</div>
                ) : (
                    <div className="yr-map-legend__value">{legendItem.min}-{legendItem.max}</div>
                )}

            </div>
        ))}
    </div>
);

YRMapLegend.propTypes = {
    legendData: PropTypes.arrayOf(PropTypes.any).isRequired,
};

export default YRMapLegend;
